const customerLicenseTypes = (licenses) => {
  const types = new Set();
  (licenses ?? []).forEach((lic) => {
    (lic.lcnsInfo?.lcnsTypes ?? []).forEach((type) => types.add(type));
  });
  return types;
};

export default customerLicenseTypes;
